import { render, staticRenderFns } from "./tab-platform.vue?vue&type=template&id=1da9a0b8"
import script from "./tab-platform.vue?vue&type=script&lang=js"
export * from "./tab-platform.vue?vue&type=script&lang=js"
import style0 from "./tab-platform.vue?vue&type=style&index=0&id=1da9a0b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports